// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .account-page-wrapper {
  padding-top: 90px;
}

.account-transation-main-wrapper {
  padding-top: 90px;
} */
.account-detail-main-wrapper {
  /* padding-top: 90px; */
  /* background-image: url("../../assets/images/profile-bg.png"); */
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed;
  /* height: 100vh; */
}


.account-header-left {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
}

.account-header-left img {
  width: 70px;
}

.acc-transaction-header p {
  font-size: 20px;
}

.account-table-wrapper {
  margin-top: 20px;
}

button.status-upload {
  font-size: 18px;
  color: #383838;
  background-color: #D9ECFF;
  border: none;
  border-radius: 8px;
  width: 141px;
  height: 42px;
}

.status-No-verify {
  font-size: 18px;
  color: #383838;
  background-color: #9B9B9B;
  border: none;
  border-radius: 8px;
  width: 141px;
  height: 42px;
}

.status-verify {
  font-size: 18px;
  color: #fff;
  background-color: #00A19B;
  border: none;
  border-radius: 8px;
  width: 141px;
  height: 42px;
}

.action-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
}

.action-icons svg {
  font-size: 25px;
  cursor: pointer;
}

.action-icons svg:hover {
  color: #00A19B;
}

.account-detail-header {
  border-bottom: 2px solid rgb(133 133 133 / 27%);
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 79px;
}

.create-order-header-wrap{
  border-bottom: none;
  padding-bottom: 0px;
}

.account-detail-tabs-wrap {
  display: flex;
  gap: 40px;
}

.account-detail-left-tabs-wrap {
  display: flex;
  gap: 20px;
  margin-right: 80px;
}

.account-detail-header h2 {
  font-size: 38px;
  color: #383838;
  margin: 0px;
}

.account-detail-header h3 {
  font-size: 24px;
  color: #383838;
  opacity: 50%;
  margin-top: 10px;
  cursor: pointer;
}

.account-detail-left-tabs-wrap h3 {
  font-size: 22px;
  color: #383838;
  opacity: 100%;
  margin-top: 10px;
  cursor: pointer;
}

.account-detail-left-tabs-wrap a {
  font-size: 22px;
  color: #383838;
  opacity: 100%;
  margin-top: 10px;
  cursor: pointer;
  text-decoration: none;
}

.account-detail-left-tabs-wrap a:hover {
  color: #fbc425;
}

.account-detail-left-tabs-wrap h3:hover {
  color: #fbc425;
}

.account-tab-active h3 {
  font-size: 24px;
  color: #383838;
  opacity: 100%;
  padding-bottom: 10px;
  margin-top: 10px;
  border-bottom: 3px solid #fbc425;
}

.account-profile img {
  width: 133px;
  height: 133px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  background-origin: border-box;
  box-shadow: inset 2px 1000px 1px #fff;
}

.account-detail-profile-wrap {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.account-profile-left {
  display: flex;
  gap: 37px;
}

.account-detail-profile-wrapper {
  /* margin-top: 80px; */
}

.account-detail-profile-wrapper img{
  cursor: pointer;
}

.account-detail-profile-wrapper img:hover{
  scale: 0.9;
}

.account-profile-info .username {
  margin-bottom: 25px;
}

.account-profile-info .username h3 {
  font-size: 36px;
  font-weight: 600;
  color: #383838;
  margin: 0px;
}

.account-info-wrap {
  display: flex;
  gap: 90px;
  padding-bottom: 20px;
}

.account-profile-info .username p {
  font-size: 24px;
  color: #5b5b5b;
}

.account-info-wrap h4 {
  min-width: 220px;
  font-size: 24px;
  font-weight: 600;
  margin: 0px;
  color: #383838;
}

.account-info-wrap span.time {
  margin-left: 15px;
}

.account-info-wrap h5 {
  font-size: 24px;
  font-weight: 500;
  margin: 0px;
  color: #5B5B5B
}

.account-profile-right {
  text-align: center;
}

.account-profile-right h2 {
  font-size: 46px;
  color: #383838;
  padding-bottom: 20px;
}

.account-profile-right h4 {
  font-size: 24px;
  font-weight: 500;
  margin-top: 18px;
}

.account-profile-right h3 {
  font-size: 38px;
  font-weight: 500;
  color: #25e101;
}

.account-profile-right button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 8px 40px;
  font-size: 24px;
  font-weight: 500;
  margin-top: 46px;
}

.account-profile-right button:hover {
  background-color: var(--buttonHover);
}

.profile-activity-wrapper {
  margin-top: 80px;
}

.profile-activity-wrapper h2 {
  font-size: 30px;
  color: #383838;
  margin-bottom: 30px;
}

.acc-transaction-header {
  /* width: 100%; */
  display: flex;
  align-items: center;
  gap: 45%;
  padding: 26px 0px;
  background-color: #fff;
}

.acc-transaction-header-wrapper {
  position: fixed;
  width: 70%;
  /* overflow: scroll; */
  background: #fff;
  top: 80px;
  z-index: 12;
}

.acc-transaction-table-handler {
  margin-top: 250px;
}

.balance-acc {
  display: flex;
  display: flex;
  align-items: center;
  gap: 50px;
  margin-top: 0px;
}

.trasfer-histroy-wrapper-acc .transfer-history-header h3 {
  font-size: 38px !important;
  margin-top: 52px;
}

.trasfer-histroy-wrapper-acc {
  padding-bottom: 80px;
  background-image: linear-gradient(
    to right,
    #383838 50%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: bottom;
  background-size: 20px 2px;
  background-repeat: repeat-x;
}

.acc-transaction-header img {
  cursor: pointer;
}

/* .active-Id {
  padding-top: 200px;
} */

.account-info-wrap button {
  font-size: 18px;
  padding: 6px 20px;
  color: #fff;
  background-color: #00A19B;
  border: none;
  border-radius: 6px;
}

.account-info-wrap button:hover{
  background-color: #008081;
}

.account-info-wrap button a{
  color: #fff;
  text-decoration: none;
}


/****************** toggle button Customer view and history css *****/
.ip-whitelist-switch-wrapper .switches-container {
  width: 525px;
  height: 65px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
  position: relative;
  background:#F8F8F8;
  line-height: 3rem;
  border-radius: 6px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
}

/* input (radio) for toggling. hidden - use labels for clicking on */
.ip-whitelist-switch-wrapper .switches-container input {
  visibility: hidden;
  position: absolute;
  top: 0;
}

/* labels for the input (radio) boxes - something to click on */
.ip-whitelist-switch-wrapper .switches-container label {
  width: 50%;
  padding: 0;
  margin: 0;
  text-align: center;
  cursor: pointer;
  color: #D4D4D4;
  font-size: 22px;
}

/* switch highlighters wrapper (sliding left / right) 
  - need wrapper to enable the even margins around the highlight box
*/
.ip-whitelist-switch-wrapper .switch-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  padding: 0.15rem;
  z-index: 3;
  transition: transform .5s cubic-bezier(.77, 0, .175, 1);
  /* transition: transform 1s; */
}

/* switch box highlighter */
.ip-whitelist-switch-wrapper .switch {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 6px;
  background: #00A19B;
  height: 100%;
}

/* switch box labels
  - default setup
  - toggle afterwards based on radio:checked status 
*/
.ip-whitelist-switch-wrapper .switch div {
  width: 100%;
  text-align: center;
  opacity: 0;
  display: block;
  color: #fff ;
  transition: opacity .2s cubic-bezier(.77, 0, .175, 1) .125s;
  will-change: opacity;
  position: absolute;
  top: 16;
  left: 0;
  font-size: 22px;
}

/* slide the switch box from right to left */
.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(1):checked~.switch-wrapper {
  transform: translateX(0%);
}

/* slide the switch box from left to right */
.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(2):checked~.switch-wrapper {
  transform: translateX(100%);
}

/* toggle the switch box labels - first checkbox:checked - show first switch div */
.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(1):checked~.switch-wrapper .switch div:nth-of-type(1) {
  opacity: 1;
}

/* toggle the switch box labels - second checkbox:checked - show second switch div */
.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(2):checked~.switch-wrapper .switch div:nth-of-type(2) {
  opacity: 1;
}


.account-profile-right img {
  width: 106px;
  height: 138px;
}


.account-profile-right button {
  background: #00A19B !important;
  color: #fff;
  width: 233px;
  height: 65px;
  border-radius: 10px;
  font-size: 20px;
  margin-top: 20px;
}


.account-profile-right button:hover{
  background: #fff !important;
  color: #383838;
  border: 2px solid #00A19B;
}

.account-profile-right img {
  margin-top: 0px;
}


.account-table-wrapper .table > tbody {
  border-left: unset;
  border-right: unset;
  /* border-top: unset !important; */
}

.account-table-wrapper table tr td{
  border-left: unset !important;
}

.table-status-icon img{
  width: 28px;
}

img.type-icon-wrap {
  width: 18px;
}

.account-profile-head {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 16px;
  margin-bottom: 25px;
  position: relative;
}


.profile-edit-button {
  width: 94px;
  height: 30px;
  border-radius: 35px;
  gap: 8px;
  background: #00A19B;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.profile-edit-button:hover{
  background: #008081;
}

.account-profile-head h3 {
    font-size: 30px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.profile-edit-button p {
  font-size: 16px;
  color: #FFFFFF;
  margin: 0px;
  font-weight: 500;
}


.profile-activity-table .table > tbody {
  border-left: unset;
  border-right: unset;
  /* border-top: unset !important; */
}

.profile-activity-table table tr td{
  border-left: unset !important;

}

.account-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
}

.account-search-main-wrap input {
  width: 351px;
  height: 52px;
  border: 1px solid #00A19B;
  border-radius: 9px;
  font-size: 16px;
  outline: none;
  padding: 0px 20px 0px 40px;
}


.account-search-main-wrap input:hover {
  border: 1px solid #008081;
}


.account-search-main-wrap{
  position: relative;
  margin-top: 50px;
}

.search-icon {
  position: absolute;
  top: 14px;
  left: 10px;
}

.account-search-main-wrap input::placeholder{
  color: #A7A7A7;
}

.application-status-wrap h4 {
  font-size: 30px;
  color: #1A1919;
  font-weight: 500;
  margin: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

.application-status-change-dropdown {
  margin-top: -6px;
}



.create-order-btn-main-wrap {
  width: 233px;
  height: 70px;
  background: #00A19B;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  cursor: pointer;
}

.create-order-btn-main-wrap p{
  font-size: 22px;
  color: #fff;
  font-weight: 400;
  margin: 0px;
}

img.table-postpaid-icon{
  width: 24px;
}

.account-header-right-main-wrap{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 30px;
}

.account-header-status-filter{
  width: 250px;
}

.account-header-status-filter .react-dropdown .react-dropdown-btn {
  height: 52px;
}

.account-header-status-filter .react-dropdown .dropdown-content .dropdown-item {
  width: 92%;
}

.account-table-wrapper{
  margin-top: 10px;
}

img.not-uploaded-icon{
  width: 21px;
  height: 21px;
}

.account-header-right-main-wrap{
  overflow: unset !important;
}



@media(max-width: 767px){

  .account-detail-header{
    padding: 20px 0px;
  }

  .ip-whitelist-switch-wrapper .switches-container {
    width: 100%;
    height: 62px;
  }

  .add-ip-content {
    width: 100%;
  }

  .add-ip-code input {
    width: 70px;
    height: 55px;
    margin-right: 5px;
  }

  .add-ip-content p {
    font-size: 18px;
    color: #383838;
    text-align: center;
  }

  .ip-whitelist-switch-wrapper .switch div{
    font-size: 15px;
  }

  .ip-whitelist-switch-wrapper .switches-container label{
    font-size: 15px;
  }

  .login-change-form.ip-whitelist-input h2 {
    font-size: 22px;
  }

  .login-change-form.ip-whitelist-input .add-ip-code {
    margin-bottom: 60px;
  }

  .login-change-form.ip-whitelist-input {
    margin-top: 60px;
  }

  .IpAddress-table-wrapper.table-responsive table#transfer{
    min-width: 700px;
  }

  table#transfer tr th {
    font-size: 20px;
  }

  table#transfer tbody tr td {
    padding: 16px;
  }

  .confirm-button-wrap button {
    height: 50px;
  }

  .ip-button-wrapper button.confirm-button{
    width: 150px;
    height: 50px;
  }

  .ip-button-wrapper button.cancel-button{
    width: 150px;
    height: 50px;
  }

  .account-header-left{
    display: none;
  }

  .account-profile img {
    width: 150px;
    height: 150px;
  }

  .account-profile{
    margin-top: 90px;
  }

  .account-search-main-wrap input {
    width: 300px;
    height: 52px;
  }

  .account-header-right-main-wrap {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    margin-bottom: 20px;
  }

  .account-search-main-wrap {
    position: relative;
    margin-top: 30px;
  }

  .profile-edit-button p {
    font-size: 12px;
  }

  .profile-edit-button {
    cursor: pointer;
  }


  .account-profile-head {
    z-index: 99;
  }

 }


 @media(max-width: 360px){
  .ip-whitelist-switch-wrapper .switches-container label {
    font-size: 14px;
  }

  .ip-whitelist-switch-wrapper .switches-container label {
        font-size: 14px;
    }

    .ip-whitelist-switch-wrapper .switch div {
          font-size: 14px;
    }

    .account-detail-header{
      padding: 20px 0px;
    }
 }

 @media(max-width: 355px){
  .ip-whitelist-switch-wrapper .switches-container {
    width: 300px;
    height: 62px;
  }

  .add-ip-content p {
    font-size: 16px;
  }

  .login-change-form.ip-whitelist-input h2 {
    font-size: 20px;
  }

  .add-ip-code input {
    width: 70px;
    height: 55px;
    margin-right: 0px;
  }

  .confirm-button-wrap button {
    height: 50px;
  }

  .ip-whitelist-switch-wrapper .switches-container label {
    font-size: 12px;
  }

  .ip-whitelist-switch-wrapper .switches-container label {
        font-size: 12px;
    }

    .ip-whitelist-switch-wrapper .switch div {
          font-size: 12px;
    }


}


 @media(min-width: 768px) and (max-width: 1199px){
  .ip-whitelist-switch-wrapper .switches-container {
    width: 525px;
    height: 62px;
  }

  .ip-whitelist-switch-wrapper .switch div{
    font-size: 20px;
  }

  .ip-whitelist-switch-wrapper .switches-container label{
    font-size: 20px;
  }

  .add-ip-content p {
    font-size: 16px;
  }

  .add-ip-content {
    width: 600px;
    padding: 10px 0px;
  }

  .login-change-form.ip-whitelist-input h2 {
    text-align: left;
    font-size: 20px;
    margin-top: 0px;
    margin-bottom: 10px;
}

  .add-ip-code input {
    border-radius: 10px;
    text-align: center;
    width: 120px;
    height: 65px;
  }

  .IpAddress-table-wrapper.table-responsive table#transfer {
    min-width: 1000px !important;
  }

  td.expend-delete-button {
    width: 450px;
  }

  tr.expend-delete-button td {
    border-right: none !important;
  }

  .ip-button-wrapper button.confirm-button {
    height: 50px;
  }

  .ip-button-wrapper button.cancel-button{
    height: 50px;
  }


  .account-search-main-wrap input {
    width: 300px;
    height: 52px;
  }

  .account-profile-info .username p {
    font-size: 22px;
  }

  .account-profile-info .username h3 {
    font-size: 24px;
  }

  .account-info-wrap h4 {
    font-size: 18px;
  }

  .account-info-wrap h5 {
    font-size: 18px;
  }

  .invoice-status-wrapper h4 {
    font-size: 24px;
  }

  .invoce-status-btn-wrap p {
    font-size: 18px;
  }

  .invoce-status-btn-wrap {
    width: 230px;
    height: 55px;
  }

  .profile-activity-wrapper h2 {
    font-size: 26px;
  }
  
 }

@media (min-width: 1025px) and (max-width: 1599px){
  .ip-whitelist-switch-wrapper .switches-container {
    width: 480px;
  }

  .ip-whitelist-switch-wrapper .switch div {
    font-size: 20px;
  }

  .ip-whitelist-switch-wrapper .switches-container label{
    font-size: 20px;
  }

  .account-profile-info .username h3 {
    font-size: 24px;
  }

  .account-profile img {
    width: 100px;
    height: 100px;
  }
  .account-profile-info .username p {
    font-size: 18px;
  }

  .account-info-wrap h4 {
    min-width: 150px;
  }

  .account-profile-head h3 {
    font-size: 28px;
  }

  .profile-edit-button p {
    font-size: 14px;
  }

}


@media (min-width: 1024px) and (max-width: 1199px){
  .account-detail-header h2 {
    font-size: 28px;
    width: 140px;
    color: #383838;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/Account/Account.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;AACH;EACE,uBAAuB;EACvB,iEAAiE;EACjE,qCAAqC;EACrC,uCAAuC;EACvC,4BAA4B;EAC5B,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB;;;;GAIC;EACD,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;;AAGA,qEAAqE;AACrE;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;AACR;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,uDAAuD;EACvD,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,2DAA2D;EAC3D,oBAAoB;EACpB,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;AAC7B;;AAEA,kFAAkF;AAClF;EACE,UAAU;AACZ;;AAEA,oFAAoF;AACpF;EACE,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,0BAA0B;AAC5B;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,WAAW;EACb;;CAED;;;CAGA;EACC;IACE,eAAe;EACjB;;EAEA;QACM,eAAe;IACnB;;IAEA;UACM,eAAe;IACrB;;IAEA;MACE,iBAAiB;IACnB;CACH;;CAEA;EACC;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;QACM,eAAe;IACnB;;IAEA;UACM,eAAe;IACrB;;;AAGJ;;;CAGC;EACC;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;EAEE;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;CAED;;AAED;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,eAAe;IACf,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;AACF","sourcesContent":["/* .account-page-wrapper {\n  padding-top: 90px;\n}\n\n.account-transation-main-wrapper {\n  padding-top: 90px;\n} */\n.account-detail-main-wrapper {\n  /* padding-top: 90px; */\n  /* background-image: url(\"../../assets/images/profile-bg.png\"); */\n  background-size: 100% 100% !important;\n  background-repeat: no-repeat !important;\n  background-attachment: fixed;\n  /* height: 100vh; */\n}\n\n\n.account-header-left {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0px;\n}\n\n.account-header-left img {\n  width: 70px;\n}\n\n.acc-transaction-header p {\n  font-size: 20px;\n}\n\n.account-table-wrapper {\n  margin-top: 20px;\n}\n\nbutton.status-upload {\n  font-size: 18px;\n  color: #383838;\n  background-color: #D9ECFF;\n  border: none;\n  border-radius: 8px;\n  width: 141px;\n  height: 42px;\n}\n\n.status-No-verify {\n  font-size: 18px;\n  color: #383838;\n  background-color: #9B9B9B;\n  border: none;\n  border-radius: 8px;\n  width: 141px;\n  height: 42px;\n}\n\n.status-verify {\n  font-size: 18px;\n  color: #fff;\n  background-color: #00A19B;\n  border: none;\n  border-radius: 8px;\n  width: 141px;\n  height: 42px;\n}\n\n.action-icons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.action-icons svg {\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.action-icons svg:hover {\n  color: #00A19B;\n}\n\n.account-detail-header {\n  border-bottom: 2px solid rgb(133 133 133 / 27%);\n  padding: 20px;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 79px;\n}\n\n.create-order-header-wrap{\n  border-bottom: none;\n  padding-bottom: 0px;\n}\n\n.account-detail-tabs-wrap {\n  display: flex;\n  gap: 40px;\n}\n\n.account-detail-left-tabs-wrap {\n  display: flex;\n  gap: 20px;\n  margin-right: 80px;\n}\n\n.account-detail-header h2 {\n  font-size: 38px;\n  color: #383838;\n  margin: 0px;\n}\n\n.account-detail-header h3 {\n  font-size: 24px;\n  color: #383838;\n  opacity: 50%;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.account-detail-left-tabs-wrap h3 {\n  font-size: 22px;\n  color: #383838;\n  opacity: 100%;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.account-detail-left-tabs-wrap a {\n  font-size: 22px;\n  color: #383838;\n  opacity: 100%;\n  margin-top: 10px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.account-detail-left-tabs-wrap a:hover {\n  color: #fbc425;\n}\n\n.account-detail-left-tabs-wrap h3:hover {\n  color: #fbc425;\n}\n\n.account-tab-active h3 {\n  font-size: 24px;\n  color: #383838;\n  opacity: 100%;\n  padding-bottom: 10px;\n  margin-top: 10px;\n  border-bottom: 3px solid #fbc425;\n}\n\n.account-profile img {\n  width: 133px;\n  height: 133px;\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n  background-origin: border-box;\n  box-shadow: inset 2px 1000px 1px #fff;\n}\n\n.account-detail-profile-wrap {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.account-profile-left {\n  display: flex;\n  gap: 37px;\n}\n\n.account-detail-profile-wrapper {\n  /* margin-top: 80px; */\n}\n\n.account-detail-profile-wrapper img{\n  cursor: pointer;\n}\n\n.account-detail-profile-wrapper img:hover{\n  scale: 0.9;\n}\n\n.account-profile-info .username {\n  margin-bottom: 25px;\n}\n\n.account-profile-info .username h3 {\n  font-size: 36px;\n  font-weight: 600;\n  color: #383838;\n  margin: 0px;\n}\n\n.account-info-wrap {\n  display: flex;\n  gap: 90px;\n  padding-bottom: 20px;\n}\n\n.account-profile-info .username p {\n  font-size: 24px;\n  color: #5b5b5b;\n}\n\n.account-info-wrap h4 {\n  min-width: 220px;\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0px;\n  color: #383838;\n}\n\n.account-info-wrap span.time {\n  margin-left: 15px;\n}\n\n.account-info-wrap h5 {\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0px;\n  color: #5B5B5B\n}\n\n.account-profile-right {\n  text-align: center;\n}\n\n.account-profile-right h2 {\n  font-size: 46px;\n  color: #383838;\n  padding-bottom: 20px;\n}\n\n.account-profile-right h4 {\n  font-size: 24px;\n  font-weight: 500;\n  margin-top: 18px;\n}\n\n.account-profile-right h3 {\n  font-size: 38px;\n  font-weight: 500;\n  color: #25e101;\n}\n\n.account-profile-right button {\n  background: var(--buttonColor);\n  border-radius: 5px;\n  opacity: 1;\n  border: none;\n  color: #383838;\n  padding: 8px 40px;\n  font-size: 24px;\n  font-weight: 500;\n  margin-top: 46px;\n}\n\n.account-profile-right button:hover {\n  background-color: var(--buttonHover);\n}\n\n.profile-activity-wrapper {\n  margin-top: 80px;\n}\n\n.profile-activity-wrapper h2 {\n  font-size: 30px;\n  color: #383838;\n  margin-bottom: 30px;\n}\n\n.acc-transaction-header {\n  /* width: 100%; */\n  display: flex;\n  align-items: center;\n  gap: 45%;\n  padding: 26px 0px;\n  background-color: #fff;\n}\n\n.acc-transaction-header-wrapper {\n  position: fixed;\n  width: 70%;\n  /* overflow: scroll; */\n  background: #fff;\n  top: 80px;\n  z-index: 12;\n}\n\n.acc-transaction-table-handler {\n  margin-top: 250px;\n}\n\n.balance-acc {\n  display: flex;\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  margin-top: 0px;\n}\n\n.trasfer-histroy-wrapper-acc .transfer-history-header h3 {\n  font-size: 38px !important;\n  margin-top: 52px;\n}\n\n.trasfer-histroy-wrapper-acc {\n  padding-bottom: 80px;\n  background-image: linear-gradient(\n    to right,\n    #383838 50%,\n    rgba(255, 255, 255, 0) 0%\n  );\n  background-position: bottom;\n  background-size: 20px 2px;\n  background-repeat: repeat-x;\n}\n\n.acc-transaction-header img {\n  cursor: pointer;\n}\n\n/* .active-Id {\n  padding-top: 200px;\n} */\n\n.account-info-wrap button {\n  font-size: 18px;\n  padding: 6px 20px;\n  color: #fff;\n  background-color: #00A19B;\n  border: none;\n  border-radius: 6px;\n}\n\n.account-info-wrap button:hover{\n  background-color: #008081;\n}\n\n.account-info-wrap button a{\n  color: #fff;\n  text-decoration: none;\n}\n\n\n/****************** toggle button Customer view and history css *****/\n.ip-whitelist-switch-wrapper .switches-container {\n  width: 525px;\n  height: 65px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  position: relative;\n  background:#F8F8F8;\n  line-height: 3rem;\n  border-radius: 6px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 0px;\n}\n\n/* input (radio) for toggling. hidden - use labels for clicking on */\n.ip-whitelist-switch-wrapper .switches-container input {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n}\n\n/* labels for the input (radio) boxes - something to click on */\n.ip-whitelist-switch-wrapper .switches-container label {\n  width: 50%;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n  cursor: pointer;\n  color: #D4D4D4;\n  font-size: 22px;\n}\n\n/* switch highlighters wrapper (sliding left / right) \n  - need wrapper to enable the even margins around the highlight box\n*/\n.ip-whitelist-switch-wrapper .switch-wrapper {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 50%;\n  padding: 0.15rem;\n  z-index: 3;\n  transition: transform .5s cubic-bezier(.77, 0, .175, 1);\n  /* transition: transform 1s; */\n}\n\n/* switch box highlighter */\n.ip-whitelist-switch-wrapper .switch {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 6px;\n  background: #00A19B;\n  height: 100%;\n}\n\n/* switch box labels\n  - default setup\n  - toggle afterwards based on radio:checked status \n*/\n.ip-whitelist-switch-wrapper .switch div {\n  width: 100%;\n  text-align: center;\n  opacity: 0;\n  display: block;\n  color: #fff ;\n  transition: opacity .2s cubic-bezier(.77, 0, .175, 1) .125s;\n  will-change: opacity;\n  position: absolute;\n  top: 16;\n  left: 0;\n  font-size: 22px;\n}\n\n/* slide the switch box from right to left */\n.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(1):checked~.switch-wrapper {\n  transform: translateX(0%);\n}\n\n/* slide the switch box from left to right */\n.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(2):checked~.switch-wrapper {\n  transform: translateX(100%);\n}\n\n/* toggle the switch box labels - first checkbox:checked - show first switch div */\n.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(1):checked~.switch-wrapper .switch div:nth-of-type(1) {\n  opacity: 1;\n}\n\n/* toggle the switch box labels - second checkbox:checked - show second switch div */\n.ip-whitelist-switch-wrapper .switches-container input:nth-of-type(2):checked~.switch-wrapper .switch div:nth-of-type(2) {\n  opacity: 1;\n}\n\n\n.account-profile-right img {\n  width: 106px;\n  height: 138px;\n}\n\n\n.account-profile-right button {\n  background: #00A19B !important;\n  color: #fff;\n  width: 233px;\n  height: 65px;\n  border-radius: 10px;\n  font-size: 20px;\n  margin-top: 20px;\n}\n\n\n.account-profile-right button:hover{\n  background: #fff !important;\n  color: #383838;\n  border: 2px solid #00A19B;\n}\n\n.account-profile-right img {\n  margin-top: 0px;\n}\n\n\n.account-table-wrapper .table > tbody {\n  border-left: unset;\n  border-right: unset;\n  /* border-top: unset !important; */\n}\n\n.account-table-wrapper table tr td{\n  border-left: unset !important;\n}\n\n.table-status-icon img{\n  width: 28px;\n}\n\nimg.type-icon-wrap {\n  width: 18px;\n}\n\n.account-profile-head {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-top: 16px;\n  margin-bottom: 25px;\n  position: relative;\n}\n\n\n.profile-edit-button {\n  width: 94px;\n  height: 30px;\n  border-radius: 35px;\n  gap: 8px;\n  background: #00A19B;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.profile-edit-button:hover{\n  background: #008081;\n}\n\n.account-profile-head h3 {\n    font-size: 30px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.profile-edit-button p {\n  font-size: 16px;\n  color: #FFFFFF;\n  margin: 0px;\n  font-weight: 500;\n}\n\n\n.profile-activity-table .table > tbody {\n  border-left: unset;\n  border-right: unset;\n  /* border-top: unset !important; */\n}\n\n.profile-activity-table table tr td{\n  border-left: unset !important;\n\n}\n\n.account-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 20px;\n}\n\n.account-search-main-wrap input {\n  width: 351px;\n  height: 52px;\n  border: 1px solid #00A19B;\n  border-radius: 9px;\n  font-size: 16px;\n  outline: none;\n  padding: 0px 20px 0px 40px;\n}\n\n\n.account-search-main-wrap input:hover {\n  border: 1px solid #008081;\n}\n\n\n.account-search-main-wrap{\n  position: relative;\n  margin-top: 50px;\n}\n\n.search-icon {\n  position: absolute;\n  top: 14px;\n  left: 10px;\n}\n\n.account-search-main-wrap input::placeholder{\n  color: #A7A7A7;\n}\n\n.application-status-wrap h4 {\n  font-size: 30px;\n  color: #1A1919;\n  font-weight: 500;\n  margin: 0px;\n  margin-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.application-status-change-dropdown {\n  margin-top: -6px;\n}\n\n\n\n.create-order-btn-main-wrap {\n  width: 233px;\n  height: 70px;\n  background: #00A19B;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  cursor: pointer;\n}\n\n.create-order-btn-main-wrap p{\n  font-size: 22px;\n  color: #fff;\n  font-weight: 400;\n  margin: 0px;\n}\n\nimg.table-postpaid-icon{\n  width: 24px;\n}\n\n.account-header-right-main-wrap{\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.account-header-status-filter{\n  width: 250px;\n}\n\n.account-header-status-filter .react-dropdown .react-dropdown-btn {\n  height: 52px;\n}\n\n.account-header-status-filter .react-dropdown .dropdown-content .dropdown-item {\n  width: 92%;\n}\n\n.account-table-wrapper{\n  margin-top: 10px;\n}\n\nimg.not-uploaded-icon{\n  width: 21px;\n  height: 21px;\n}\n\n.account-header-right-main-wrap{\n  overflow: unset !important;\n}\n\n\n\n@media(max-width: 767px){\n\n  .account-detail-header{\n    padding: 20px 0px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container {\n    width: 100%;\n    height: 62px;\n  }\n\n  .add-ip-content {\n    width: 100%;\n  }\n\n  .add-ip-code input {\n    width: 70px;\n    height: 55px;\n    margin-right: 5px;\n  }\n\n  .add-ip-content p {\n    font-size: 18px;\n    color: #383838;\n    text-align: center;\n  }\n\n  .ip-whitelist-switch-wrapper .switch div{\n    font-size: 15px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container label{\n    font-size: 15px;\n  }\n\n  .login-change-form.ip-whitelist-input h2 {\n    font-size: 22px;\n  }\n\n  .login-change-form.ip-whitelist-input .add-ip-code {\n    margin-bottom: 60px;\n  }\n\n  .login-change-form.ip-whitelist-input {\n    margin-top: 60px;\n  }\n\n  .IpAddress-table-wrapper.table-responsive table#transfer{\n    min-width: 700px;\n  }\n\n  table#transfer tr th {\n    font-size: 20px;\n  }\n\n  table#transfer tbody tr td {\n    padding: 16px;\n  }\n\n  .confirm-button-wrap button {\n    height: 50px;\n  }\n\n  .ip-button-wrapper button.confirm-button{\n    width: 150px;\n    height: 50px;\n  }\n\n  .ip-button-wrapper button.cancel-button{\n    width: 150px;\n    height: 50px;\n  }\n\n  .account-header-left{\n    display: none;\n  }\n\n  .account-profile img {\n    width: 150px;\n    height: 150px;\n  }\n\n  .account-profile{\n    margin-top: 90px;\n  }\n\n  .account-search-main-wrap input {\n    width: 300px;\n    height: 52px;\n  }\n\n  .account-header-right-main-wrap {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 2px;\n    margin-bottom: 20px;\n  }\n\n  .account-search-main-wrap {\n    position: relative;\n    margin-top: 30px;\n  }\n\n  .profile-edit-button p {\n    font-size: 12px;\n  }\n\n  .profile-edit-button {\n    cursor: pointer;\n  }\n\n\n  .account-profile-head {\n    z-index: 99;\n  }\n\n }\n\n\n @media(max-width: 360px){\n  .ip-whitelist-switch-wrapper .switches-container label {\n    font-size: 14px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container label {\n        font-size: 14px;\n    }\n\n    .ip-whitelist-switch-wrapper .switch div {\n          font-size: 14px;\n    }\n\n    .account-detail-header{\n      padding: 20px 0px;\n    }\n }\n\n @media(max-width: 355px){\n  .ip-whitelist-switch-wrapper .switches-container {\n    width: 300px;\n    height: 62px;\n  }\n\n  .add-ip-content p {\n    font-size: 16px;\n  }\n\n  .login-change-form.ip-whitelist-input h2 {\n    font-size: 20px;\n  }\n\n  .add-ip-code input {\n    width: 70px;\n    height: 55px;\n    margin-right: 0px;\n  }\n\n  .confirm-button-wrap button {\n    height: 50px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container label {\n    font-size: 12px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container label {\n        font-size: 12px;\n    }\n\n    .ip-whitelist-switch-wrapper .switch div {\n          font-size: 12px;\n    }\n\n\n}\n\n\n @media(min-width: 768px) and (max-width: 1199px){\n  .ip-whitelist-switch-wrapper .switches-container {\n    width: 525px;\n    height: 62px;\n  }\n\n  .ip-whitelist-switch-wrapper .switch div{\n    font-size: 20px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container label{\n    font-size: 20px;\n  }\n\n  .add-ip-content p {\n    font-size: 16px;\n  }\n\n  .add-ip-content {\n    width: 600px;\n    padding: 10px 0px;\n  }\n\n  .login-change-form.ip-whitelist-input h2 {\n    text-align: left;\n    font-size: 20px;\n    margin-top: 0px;\n    margin-bottom: 10px;\n}\n\n  .add-ip-code input {\n    border-radius: 10px;\n    text-align: center;\n    width: 120px;\n    height: 65px;\n  }\n\n  .IpAddress-table-wrapper.table-responsive table#transfer {\n    min-width: 1000px !important;\n  }\n\n  td.expend-delete-button {\n    width: 450px;\n  }\n\n  tr.expend-delete-button td {\n    border-right: none !important;\n  }\n\n  .ip-button-wrapper button.confirm-button {\n    height: 50px;\n  }\n\n  .ip-button-wrapper button.cancel-button{\n    height: 50px;\n  }\n\n\n  .account-search-main-wrap input {\n    width: 300px;\n    height: 52px;\n  }\n\n  .account-profile-info .username p {\n    font-size: 22px;\n  }\n\n  .account-profile-info .username h3 {\n    font-size: 24px;\n  }\n\n  .account-info-wrap h4 {\n    font-size: 18px;\n  }\n\n  .account-info-wrap h5 {\n    font-size: 18px;\n  }\n\n  .invoice-status-wrapper h4 {\n    font-size: 24px;\n  }\n\n  .invoce-status-btn-wrap p {\n    font-size: 18px;\n  }\n\n  .invoce-status-btn-wrap {\n    width: 230px;\n    height: 55px;\n  }\n\n  .profile-activity-wrapper h2 {\n    font-size: 26px;\n  }\n  \n }\n\n@media (min-width: 1025px) and (max-width: 1599px){\n  .ip-whitelist-switch-wrapper .switches-container {\n    width: 480px;\n  }\n\n  .ip-whitelist-switch-wrapper .switch div {\n    font-size: 20px;\n  }\n\n  .ip-whitelist-switch-wrapper .switches-container label{\n    font-size: 20px;\n  }\n\n  .account-profile-info .username h3 {\n    font-size: 24px;\n  }\n\n  .account-profile img {\n    width: 100px;\n    height: 100px;\n  }\n  .account-profile-info .username p {\n    font-size: 18px;\n  }\n\n  .account-info-wrap h4 {\n    min-width: 150px;\n  }\n\n  .account-profile-head h3 {\n    font-size: 28px;\n  }\n\n  .profile-edit-button p {\n    font-size: 14px;\n  }\n\n}\n\n\n@media (min-width: 1024px) and (max-width: 1199px){\n  .account-detail-header h2 {\n    font-size: 28px;\n    width: 140px;\n    color: #383838;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
